import React, { useRef, useState, useCallback } from 'react'
import t from '~t'

import { Button, Popover, Layout, Separator, Icon } from '~ui'
import Menu from './menu'
import Show from './show'
import CoverSize from './coverSize'

export default function BookmarksHeaderView(props) {
    const { spaceId = 0, collection = {} } = props
    const { view } = collection

    const pin = useRef(null)
    const [menu, setMenu] = useState(false)

    const onMenuClick = useCallback(e => {
        e.preventDefault()
        setMenu(prev => !prev)
    }, [])

    const onMenuClose = useCallback(() => setMenu(false), [])

    const childProps = { ...props, spaceId, collection }

    return (
        <>
            <Button
                variant='ghost'
                ref={pin}
                title={t.s('view')}
                onMouseDown={onMenuClick}>
                <Icon name={'view_' + view} />
                <span className='hide-on-small-body'>{t.s(`view_${view}`)}</span>
            </Button>

            {menu ? (
                <Popover pin={pin} onClose={onMenuClose}>
                    <Layout>
                        <Menu {...childProps} onClose={onMenuClose} />
                        <Separator />
                        <Show {...childProps} />
                        <CoverSize {...childProps} />
                    </Layout>
                </Popover>
            ) : null}
        </>
    )
}
